<div [style.width.px]="width" class="navbar-secondary" *ngIf="componentOrTemplate">
  <ng-template
    [ngIf]="isTemplateRef"
    [ngIfThen]="templateRefTmpl"
    [ngIfElse]="componentTmpl"
  ></ng-template>
</div>

<ng-template #componentTmpl>
  <ng-template
    [ngComponentOutlet]="componentOrTemplate"
    [ngComponentOutletInjector]="componentInjector"
  >
  </ng-template>
</ng-template>

<ng-template #templateRefTmpl>
  <sn-layout-secondary-navbar-collapse-button></sn-layout-secondary-navbar-collapse-button>
  <ng-template [ngTemplateOutlet]="componentOrTemplate" [ngTemplateOutletContext]="templateContext">
  </ng-template>
</ng-template>
